
<c-app-recent
    icon      = "mdi-timeline-clock"
    :tooltip  = "$t('navtop.recent.site')"
    :loader   = "load"
    @selected = "onSelected"
>
    <template v-slot:title="{ item }">
        <div>
            Fabrik-Nr. {{ item.recent.site.fabricNo }} - {{ item.recent.site.id }}
        </div>

        <v-spacer />
        <div style="margin-top: -4px; margin-right: -8px;">
            <c-site-icon :color="item.hover ? 'white' : 'primary' " :site="item.recent.site" />
        </div>
    </template>

    <template v-slot:subtitle="{ item }" >
        <div style="margin-top: -4px;">
            {{ item.site.street }}
        </div>
        <div class="v-flex">
            <div>
                {{ item.site.zip }} {{ item.site.city }}
            </div>
            <v-spacer />
            <div style="float: right; font-size: 8pt; padding-top: 1px">
                {{ format(item.accesstime) }}
            </div>
        </div>
    </template>
</c-app-recent>
